import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import { initSentry } from '@lib/sentry';
import { AppProviders } from '@providers/app-providers';
import { ErrorBoundary } from './error-boundary';
import App from './App';
import './index.css';

// Initialize Sentry before rendering
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>
);
